
const createGig = ({
    areaInfo, boostStatus, form, shiftsData, status
  }) => {
    const {accountId, sectionInfo, areaId, category, salary} = areaInfo
    const {noOfAvailableShifts, campaigns, range, tags, totalShifts} = shiftsData.stats

    return {
      ...form,
      ...boostStatus,
      accountId, areaId, category, salary, // areaInfo
      availableShifts: noOfAvailableShifts,
      title: `${noOfAvailableShifts} ${noOfAvailableShifts === 1 ? 'vuoro' : 'vuoroa'}: ${sectionInfo}`,
      campaigns, // campaigns that this gig's shifts belong to. TODO Sy: not sure when this is used
      startDate: range.start,
      endDate: range.end,
      expDate: form.expDate === null || form.expDate === '' ? range.end : new Date(form.expDate),
      status,
      tags, totalShifts,
      created: new Date(), // custom
    }
  }

const gigCreator = {
  createGig,
}

export default gigCreator